import { registerApp } from '@okapi/core';
import { getGlobalRouter } from '@okapi/router-react';
import { configureAppStore } from 'store/configure-store';
import { createEntry, getInitialData } from '../common';

const preloadedState = getInitialData();

const buildApplication = () => {
	const router = getGlobalRouter();

	const store = configureAppStore({ router, preloadedState, env: preloadedState.env });

	return createEntry({ router, store, remoteContext: undefined });
};

if (preloadedState?.isBot === false) {
	registerApp(__NAME__, buildApplication);
}
